import type { AxiosInstance, AxiosResponse } from 'axios';
import axios from 'axios';
import Cookies from 'js-cookie';
import { commonConstants } from 'utils/constants/common';
import { AUTH_COOKIE_NAME } from 'utils/constants/cookies';

import { Api } from './schema/Api';
import { handleError } from './errorHandlers';

// TODO: удалить после миграции на codegen UMBB-2552
const getLegacyApi = (): AxiosInstance => {
    const AUTH_COOKIE = process.env.APP_COOKIE_SESSION;

    if (AUTH_COOKIE) {
        Cookies.set(AUTH_COOKIE_NAME, AUTH_COOKIE);
    }

    const api = axios.create({
        timeout: 20000,
        withCredentials: true,
        headers: {
            'X-Client-Version': commonConstants.APP_CLIENT_VERSION,
        },
    });

    api.interceptors.response.use((response) => response, handleError());

    return api;
};

export const api = getLegacyApi();

const getCodegenApi = (): Api => {
    const AUTH_COOKIE = process.env.APP_COOKIE_SESSION;

    if (AUTH_COOKIE) {
        Cookies.set(AUTH_COOKIE_NAME, AUTH_COOKIE);
    }

    const apiCodegen = new Api({
        timeout: 20000,
        withCredentials: true,
        headers: {
            'X-Client-Version': commonConstants.APP_CLIENT_VERSION,
        },
    });

    apiCodegen.instance.interceptors.response.use(
        (response: AxiosResponse) => response,
        handleError(),
    );

    return apiCodegen;
};

export const apiCodegen = getCodegenApi();
